import axiosInstance from "./axiosInstance";


export const fetchDocuments = async () => {
  const res = await axiosInstance.get(`/Dash/get_document`);
  const raw = res.data?.data
  return raw || []
};

export const saveDocumentAPI = async (data) => {
  const res = await axiosInstance.post('/Dash/documet_upload', data);
  return res.data;
};

export const getDocument = async (url) => {
  const res = await axiosInstance.get(`/files/proxy?url=${url}`, {
    responseType: "blob", 
  });
  return res.data; 
};
